import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { GetVideosByCategory } from 'src/redux/actions'
import { Box, Text, Flex, SkeletonText } from '@chakra-ui/react'
import Carousel from '../component/Carousel'
import { useUser } from 'src/hooks/useUser'
import { ChevronLeftIcon } from '@chakra-ui/icons'
import CardLoader from 'src/component/CardLoader'
import { isMobile } from 'src/component/CourseDetail/Practice/Util'
import InfiniteScrollWrapper from 'src/component/common/InfiniteScrollWrapper/InfiniteScrollWrapper'

const VideosByCategory = ({ showAllCourse, category, setShowAllCourse, searchText, setSearchText }) => {
  const dispatch = useDispatch()
  let NoOfCards = isMobile ? 1 : 4;
  const { user: auth, isAdmin } = useUser()
  const [disableLeftArrow] = useState(false)
  const [disableRightArrow] = useState(true)
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [videosByCategory, setVideosByCategory] = useState([])

  // Load initial data when category changes
  useEffect(() => {
    const getVideosByCategory = async () => {
      // Return if categoryId doesn't exist for latest videos
      if (category?.categoryName === "Trending Videos") {
        setVideosByCategory(category?.videos || []);
        setIsLoading(false);
        setHasMore(false);
        return;
      }
      // Return if categoryId exist
      try {
        const res = await dispatch(
          GetVideosByCategory({
            categoryId: category?.categoryId,
            page,
            searchText
          })
        );

        const { videos = [], hasMore: hasMoreFromApi = false } = res?.results || {};

        setHasMore(hasMoreFromApi);
        setVideosByCategory(prev => page > 1 ? [...prev, ...videos] : videos);
      } catch (error) {
        console.error("Error fetching videos:", error);
        setHasMore(false);
      } finally {
        setIsLoading(false);
      }
    };

    if (!showAllCourse) {
      getVideosByCategory();
    }
  }, [category, page, searchText, showAllCourse, dispatch]);

  // Load Data on search
  useEffect(() => {
    if (category?.categoryName !== "Trending Videos") {
      setIsLoading(true);
      setPage(1);
      return;
    }

// locally search for trending videos
    const videos = category?.videos ?? [];

    if (searchText) {
      const filtered = videos?.filter(item =>
        item?.name?.toLowerCase()?.includes(searchText?.toLowerCase())
      );
      setVideosByCategory(filtered);
    } else {
      setVideosByCategory(videos);
    }
  }, [category, searchText]);

  // Load more Data on scroll
  const fetchMoreVideos = () => {
    if (hasMore) {
      setPage((prev) => prev + 1);
    }
  }

  return (
    <Box width="100%">
      <Flex align="center" mb={4} width="100%">
        {isLoading ? (
          <SkeletonText style={{ flex: 1 }} noOfLines={1} maxW={'150px'} />
        ) : (
          <>
            <Flex width="100%" display="flex" justifyContent="space-between" alignItems="center">
              <Text color="#2469F5" fontSize={18} fontWeight={'bolder'} textTransform="capitalize">
                {category?.categoryName}
              </Text>
              <button
                className='back-btn'
                  onClick={() => {
                    setSearchText("");
                    setShowAllCourse(true);
                  }}
              >
                <ChevronLeftIcon w={4} h={4} /> Back
              </button>
            </Flex>
          </>
        )}
      </Flex>

      <Box position="relative" w="100%" mx="auto">
        {isLoading ? (
          <>
            <Box display="flex" flexWrap="wrap" gap="16px">
              {[...Array(NoOfCards)].map((_, i) => (
                <CardLoader key={i} height='169px' maxW={'300px'} />
              ))}
            </Box>
            <Box display="flex" mt={2} flexWrap="wrap" gap="16px">
              {[...Array(NoOfCards)].map((_, i) => (
                <CardLoader key={i} height='169px' maxW={'300px'} />
              ))}
            </Box>
          </>
        ) : videosByCategory?.length > 0 ? (
          <InfiniteScrollWrapper
            dataLength={videosByCategory?.length || 0}
            fetchNextPage={fetchMoreVideos}
            hasNextPage={hasMore}
          >
            <Carousel
              auth={auth}
              isAdmin={isAdmin}
              identifier="slug"
              navUrl="video"
              showCardMetaData={false}
              pageName="explore"
              hasStartButton={false}
              data={videosByCategory}
              showProgress={true}
              disableLeftArrow={disableLeftArrow}
              disableRightArrow={disableRightArrow}
              cardWidth="300px"
              cardWHeight="169px"
              cardRatio="16/9"
            />
          </InfiniteScrollWrapper>

        ) : (
          <Box textAlign="center" py={8}>
            <Text color="gray.500">No videos available in this category</Text>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default VideosByCategory
